module.exports = __webpack_public_path__ + "img/8.21644c58.jpg";